import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    info: null
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        addUserData: (state, action) => {
            state.info = action?.payload
        }
    }
})

export const { addUserData } = userSlice.actions
export default userSlice.reducer

// const patientSlice = createSlice({
//     name: 'prescriptions',
//     initialState,
//     reducers: {
//       addPatientData: (state, { payload }) => {
//         state.newPrescriptionData = payload
//         state.allPatients = [...state.allPatients, payload]
//         console.log('got here', { payload }, { state });
//       }
//     }
//   })
  
//   export const { addPatientData } = patientSlice.actions
//   export default patientSlice.reducer